import React from 'react';
import RestorativeTable from '../RestorativeTable';
import { Player, CalendarResponse } from '../../services/Restorative';
import { RestorativeResidentData } from '../RestorativeResidentDialog/RestorativeResidentDialog';

interface RestorativePlayerListProps {
  players: Player[];
  calendarInfo: CalendarResponse;
  dates: Date[];
  nextEnabled: boolean;
  prevDateCallback: () => void;
  nextDateCallback: () => void;
  logClickCallback: (playerId: number, name: string, date: Date) => void;
  editClickCallback: (playerId: RestorativeResidentData) => void;
}

const RestorativePlayerList: React.FC<RestorativePlayerListProps> = ({
  players,
  calendarInfo,
  dates,
  nextEnabled,
  prevDateCallback,
  nextDateCallback,
  logClickCallback,
  editClickCallback,
}) => {
  return (
    <>
      <RestorativeTable
        players={players}
        calendarInfo={calendarInfo}
        dates={dates}
        prevDateCallback={() => {
          prevDateCallback();
        }}
        nextDateCallback={() => {
          nextDateCallback();
        }}
        logClickCallback={logClickCallback}
        editClickCallback={editClickCallback}
        nextEnabled={nextEnabled}
      />
    </>
  );
};

export default RestorativePlayerList;
